import React, {createContext, useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {Button, ChakraProvider} from '@salesforce/retail-react-app/app/components/shared/ui'
import {delonghiTheme, kenwoodTheme, nutribulletTheme, braunTheme} from '../theme'
import {MoonIcon} from '@chakra-ui/icons'
import {useCustomTheme} from './theme'
/* import useUtils from '../hooks/use-utils-helper'
import {useLocation} from 'react-router-dom' */

// Create a context with a default value
export const ChakraCustomContext = createContext()

const ChakraCustomProvider = ({children}) => {
    // const location = useLocation()
    const currentTheme = useCustomTheme()
    // const {isComponentsLibrary} = useUtils().currentPage(location.pathname)

    let theme
    switch (currentTheme.theme.key) {
        case 'kenwood':
            theme = kenwoodTheme
            break
        case 'braun':
            theme = braunTheme
            break
        case 'nutribullet':
            theme = nutribulletTheme
            break
        case 'delonghi':
        default:
            theme = delonghiTheme
            break
    }

    // workaround because textStyle doesn't apply to elements that have a fontSize property already defined (in this case Input)
    // related issue: https://github.com/chakra-ui/chakra-ui/issues/3884
    // suggested workaround: https://github.com/chakra-ui/chakra-ui/issues/3501#issuecomment-803610656

    delete theme.components.Input.baseStyle.field.fontSize

    return (
        <ChakraCustomContext.Provider value={theme}>
            {/* isComponentsLibrary && <SwitchThemeButton currentTheme={currentTheme} /> */}
            <ChakraProvider theme={theme}>{children}</ChakraProvider>
        </ChakraCustomContext.Provider>
    )
}

export default ChakraCustomProvider

ChakraCustomProvider.propTypes = {
    children: PropTypes.node.isRequired,
}

const SwitchThemeButton = ({currentTheme}) => {
    const [showButton, setShowButton] = useState(false)

    useEffect(() => {
        if (window.location.hostname === 'localhost') {
            setShowButton(true)
        }
    }, [])

    return showButton ? (
        <Button
            style={{
                position: 'fixed',
                bottom: '5rem',
                right: '2rem',
                zIndex: 99999,
                background: 'bisque',
                padding: '1rem',
                borderRadius: '50%',
            }}
            onClick={() => currentTheme.toggleTheme()}
        >
            <MoonIcon />
        </Button>
    ) : (
        <></>
    )
}

SwitchThemeButton.propTypes = {
    currentTheme: PropTypes.object.isRequired,
}
